import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content', 'chevron']

  toggleDay(event) {
    const card = event.currentTarget.closest('.bg-white')
    const content = card.querySelector('[data-user-monitoring-detail-target="content"]')
    const chevron = event.currentTarget.querySelector('[data-user-monitoring-detail-target="chevron"]')

    content.classList.toggle('hidden')
    if (chevron) {
      chevron.classList.toggle('rotate-180')
    }
  }
}
